import React from 'react';
import T from 'prop-types';
import Button from 'components/Button';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getMedType } from 'utils';
import './MobileRow.scss';

const MobileTreatmentRowWithCounter = ({ treatment, count, onAdd, onRemove, abfTracking }) => (
  <div
    className={cn('MobileRow', {
      'select-row': true,
      'divider': treatment.divider,
    })}
    onClick={onAdd}
  >
    <div className={cn('row-info')}>
      <i className={`fa fa-${getMedType(treatment)}`} />
      <span>
        <span>{treatment.name}</span>
        {treatment.common && (
          <span className="common">
            <FormattedMessage id="general.meds.common" />
          </span>
        )}
        {treatment.vaccine && (
          <span className="common">(<FormattedMessage id="general.vaccine" />)</span>
        )}
        {abfTracking && (
          <>
            {treatment.safe && (<span className="common">(<FormattedMessage id="general.safe" />)</span>)}
            {!treatment.safe && (<span className="common">(<FormattedMessage id="general.unsafe" />)</span>)}
          </>
        )}
      </span>
    </div>
    <div className={cn('counter-controls')} onClick={(e) => e.stopPropagation()}>
      <Button className="select-btn" small onClick={onRemove} disabled={!count}>
        <i className="fa fa-minus" />
      </Button>
      <span style={{ minWidth: 22, textAlign: 'center', display: 'inline-block' }}>{count || 0}</span>
      <Button className="select-btn" small primary onClick={onAdd}>
        <i className="fa fa-plus" />
      </Button>
    </div>
  </div>
);

MobileTreatmentRowWithCounter.propTypes = {
  treatment: T.object.isRequired,
  count: T.number.isRequired,
  onAdd: T.func.isRequired,
  onRemove: T.func.isRequired,
  abfTracking: T.bool.isRequired,
};

export default MobileTreatmentRowWithCounter;
